module.exports = __webpack_public_path__ + "img/banner3.f6e59752.jpg";